<template>
    <div 
        class="table-container" 
        :class="scrollClasses"
        v-if="companies?.length && !loading"
        ref="tableContainer"
        @scroll="handleScroll"
    >
        <table class="table-type-2 companies">
            <thead>
                <tr class="table-header">
                    <td></td>
                    <td>{{ $t('common.company_name') }}</td>
                    <td v-if="!summarized">{{ $t('common.coc') }}</td>
                    <td v-if="!summarized">{{ $t('common.phone') }}</td>
                    <td v-if="!summarized">{{ $t('common.email') }}</td>
                    <td>{{ $t('common.website') }}</td>
                    <td v-if="!summarized">{{ $t('common.full_profile_preview') }}</td>
                    <td v-if="!summarized">{{ $t('common.address') }}</td>
                    <td v-if="!summarized">{{ $t('common.postcode') }}</td>
                    <td>{{ $t('common.city') }}</td>
                    <td v-if="!summarized">{{ $t('common.geo') }}</td>
                    <td>{{ $t('common.founded') }}</td>
                    <td>{{ $t('common.orgtype') }}</td>
                    <td v-if="!summarized">{{ $t('common.linkedin') }}</td>
                    <td v-if="!summarized">{{ $t('common.facebook') }}</td>
                    <td v-if="!summarized">{{ $t('common.twitter') }}</td>
                    <td v-if="!summarized">{{ $t('common.instagram') }}</td>
                    <td v-if="!summarized">{{ $t('common.youtube') }}</td>
                    <td v-if="!summarized">{{ $t('common.pinterest') }}</td>
                    <td>{{ $t('common.sbi') }}</td>
                    <td>{{ $t('common.apps') }}</td>
                </tr>
            </thead>
            <tbody>
                <tr class="company" v-for="(company, i) in companies" :key="i">
                    <td>
                        <div class="logo-wrp">
                            <CompanyLogo 
                                :logo_url="company.logo || null"
                                :domain="(company.domain && !company.domain.includes('*')) ? company.domain : null"
                                :company_name="company.name ? company.name : (company.domain && !company.domain.includes('*')) ? company.domain : null"
                                class="company-image"
                            />
                        </div>
                    </td>
                    <td class="company-name">{{ company.name }}</td>
                    <td v-if="!summarized">{{ company.coc || company.id }}</td>
                    <td v-if="!summarized">{{ company.phone_international || '-'}}</td>
                    <td v-if="!summarized">{{ company.email || '-'}}</td>
                    <td class="website">{{ company.url || '-'}}</td>
                    <td v-if="!summarized" class="url"><a :href="company.full_profile" target="_blank" rel="external noopener">{{company.full_profile}}</a></td>
                    <td v-if="!summarized" class="address">{{ company.address || '-' }}</td>
                    <td v-if="!summarized">{{ company.postcode || '-' }}</td>
                    <td>{{ company.city || '-' }}</td>
                    <td v-if="!summarized">{{ company.geo || '-' }}</td>
                    <td>{{ company.founded || '-' }}</td>
                    <td>{{ company.orgtype || '-' }}</td>
                    <td v-if="!summarized" class="url">{{ company.linkedin_link ? company.linkedin_link : '-' }}</td>
                    <td v-if="!summarized" class="url">{{ company.facebook_link ? company.facebook_link : '-' }}</td>
                    <td v-if="!summarized" class="url">{{ company.twitter_link ? company.twitter_link : '-' }}</td>
                    <td v-if="!summarized" class="url">{{ company.instagram_link ? company.instagram_link : '-' }}</td>
                    <td v-if="!summarized" class="url">{{ company.youtube_link ? company.youtube_link : '-' }}</td>
                    <td v-if="!summarized" class="url">{{ company.pinterest_link ? company.pinterest_link : '-' }}</td>
                    <td>{{ Array.isArray(company.sbi) ? company.sbi.join(', ') : company.sbi || '-' }}</td>
                    <td>{{ Array.isArray(company.apps) ? company.apps.join(', ') : company.apps || '-' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="loading-section-type-1" v-else-if="loading">
        <div class="loading-spinner-type-1 primary"></div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useDatasetStore } from '@/stores/dataset';
    import CompanyLogo from '@/components/elements/misc/CompanyLogo';

    export default {
        name: 'SpecificationExamples',
        components: {
            CompanyLogo
        },
        props: {
            summarized: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                scrollClasses: ''
            };
        },
        computed: {
            ...mapState(useDatasetStore, ['loading', 'dataset', 'companies'])
        },
        watch: {
            companies: {
                handler() {
                    this.$nextTick(() => {
                        this.handleScroll();
                    });
                },
                deep: true
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.handleScroll();
            });
        },
        methods: {
            handleScroll() {
                if (!this.$refs.tableContainer) return;
                
                const container = this.$refs.tableContainer;
                const isScrolledLeft = container.scrollLeft > 0;
                const isScrolledRight = container.scrollLeft + container.clientWidth < container.scrollWidth;
                
                const classes = [];
                if (isScrolledLeft) classes.push('hidden-content-left');
                if (isScrolledRight) classes.push('hidden-content-right');
                
                this.scrollClasses = classes.join(' ');
            }
        }
    }
</script>